import React, { useState } from 'react';
import { signInWithPopup, GoogleAuthProvider, createUserWithEmailAndPassword, sendPasswordResetEmail, signInWithEmailAndPassword } from "firebase/auth";
import { auth } from '../firebase';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [username, setUsername] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState(null);
  const [isSignUp, setIsSignUp] = useState(false);
  const [isResetPassword, setIsResetPassword] = useState(false);

  const handleEmailChange = (e) => setEmail(e.target.value);
  const handlePasswordChange = (e) => setPassword(e.target.value);
  const handleUsernameChange = (e) => setUsername(e.target.value);
  const handleConfirmPasswordChange = (e) => setConfirmPassword(e.target.value);

  const handleEmailLogin = async (e) => {
    e.preventDefault();
    setError(null);
    
    if (!email || !password) {
      setError("Please enter both email and password.");
      return;
    }
  
    try {
      await signInWithEmailAndPassword(auth, email, password);
      // Login successful, you might want to redirect the user or update app state here
      console.log("Login successful");
    } catch (error) {
      switch (error.code) {
        case 'auth/user-not-found':
          setError("No user found with this email address.");
          break;
        case 'auth/wrong-password':
          setError("Incorrect password. Please try again.");
          break;
        case 'auth/invalid-email':
          setError("Invalid email address format.");
          break;
        case 'auth/user-disabled':
          setError("This account has been disabled. Please contact support.");
          break;
        default:
          setError("An error occurred during login. Please try again.");
          console.error("Login error:", error);
      }
    }
  };

const handleSignUp = async (e) => {
  e.preventDefault();
  setError(null);
  
  if (!email || !password || !confirmPassword) {
    setError("Please fill in all fields.");
    return;
  }
  
  if (password !== confirmPassword) {
    setError("Passwords do not match");
    return;
  }
  
  try {
    await createUserWithEmailAndPassword(auth, email, password);
    // Handle successful sign up (e.g., update user profile with username)
    console.log("Sign up successful");
    // You might want to automatically log the user in or redirect them
  } catch (error) {
    switch (error.code) {
      case 'auth/email-already-in-use':
        setError("This email is already in use. Please use a different email or try logging in.");
        break;
      case 'auth/invalid-email':
        setError("Invalid email address format.");
        break;
      case 'auth/weak-password':
        setError("Password is too weak. Please use a stronger password.");
        break;
      default:
        setError("An error occurred during sign up. Please try again.");
        console.error("Sign up error:", error);
    }
  }
};

  const handlePasswordReset = async (e) => {
    e.preventDefault();
    try {
      await sendPasswordResetEmail(auth, email);
      setError("Password reset email sent. Check your inbox.");
    } catch (error) {
      setError(error.message);
    }
  };

  const handleGoogleLogin = async () => {
    const provider = new GoogleAuthProvider();
    try {
      await signInWithPopup(auth, provider);
    } catch (error) {
      setError(error.message);
    }
  };

  if (isResetPassword) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-slate-900">
        <div className="w-full max-w-md p-8 space-y-8 bg-slate-800 rounded-lg">
          <h2 className="mt-6 text-xl font-bold text-white">Reset Password</h2>
          <form onSubmit={handlePasswordReset}>
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={handleEmailChange}
              className="w-full px-3 py-2 border border-slate-700 rounded-md bg-slate-700 text-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <button type="submit" className="w-full px-4 py-2 mt-4 text-white bg-red-600 rounded-md hover:bg-red-500 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2">
              Send Reset Email
            </button>
          </form>
          <button onClick={() => setIsResetPassword(false)} className="w-full px-4 py-2 text-white bg-slate-700 rounded-md hover:bg-slate-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-slate-500">
            Back to Login
          </button>
          {error && <p className="mt-4 text-center text-red-500">{error}</p>}
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center min-h-screen bg-slate-900">
      <div className="w-full max-w-md p-8 space-y-8 bg-slate-800 rounded-lg">
        <div className="text-center">
          <h1 className="text-4xl font-bold mb-10 text-cyan-400">TradeWise</h1>
          {error && <p className="mt-4 text-center text-red-500">{error}</p>}
          <h2 className="mt-6 text-xl font-bold text-white">{isSignUp ? 'Create an account' : 'Log In to your account'}</h2>
        </div>
        <form onSubmit={isSignUp ? handleSignUp : handleEmailLogin} className="mt-8 space-y-6">
          {isSignUp && (
            <input
              type="text"
              placeholder="Username"
              value={username}
              onChange={handleUsernameChange}
              className="w-full px-3 py-2 border border-slate-700 rounded-md bg-slate-700 text-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          )}
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={handleEmailChange}
            className="w-full px-3 py-2 border border-slate-700 rounded-md bg-slate-700 text-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={handlePasswordChange}
            className="w-full px-3 py-2 border border-slate-700 rounded-md bg-slate-700 text-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          {isSignUp && (
            <input
              type="password"
              placeholder="Confirm Password"
              value={confirmPassword}
              onChange={handleConfirmPasswordChange}
              className="w-full px-3 py-2 border border-slate-700 rounded-md bg-slate-700 text-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          )}
          {!isSignUp && (
            <div className="text-sm">
              <button onClick={() => setIsResetPassword(true)} className="font-medium text-red-400 hover:text-red-300">
                Forgot password?
              </button>
            </div>
          )}
          <button
            type="submit"
            className="w-full px-4 py-2 text-white bg-red-600 rounded-md hover:bg-red-500 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
          >
            {isSignUp ? 'Sign Up' : 'Log In'}
          </button>
        </form>
        <div className="mt-6">
          <div className="relative">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-slate-600"></div>
            </div>
            <div className="relative flex justify-center text-sm">
              <span className="px-2 text-slate-400 bg-slate-800">OR</span>
            </div>
          </div>
          <div className="mt-6">
            <button
              onClick={handleGoogleLogin}
              className="w-full px-4 py-2 text-white bg-slate-700 rounded-md hover:bg-slate-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-slate-500"
            >
              <div className="flex items-center justify-center">
              <svg className="w-6 h-6 mr-2" viewBox="0 0 24 24">
                  <path
                    fill="#4285F4"
                    d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                  />
                  <path
                    fill="#34A853"
                    d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                  />
                  <path
                    fill="#FBBC05"
                    d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                  />
                  <path
                    fill="#EA4335"
                    d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                  />
                  <path fill="none" d="M1 1h22v22H1z" />
                </svg>
                {!isSignUp ? 'Log In' : 'Sign Up'} In with Google
              </div>
            </button>
          </div>
        </div>
        <div className="text-center mt-4">
          <p className="text-sm text-slate-400">
            {isSignUp ? 'Already have an account?' : "Don't have an account?"}{' '}
            <button onClick={() => setIsSignUp(!isSignUp)} className="font-medium text-red-400 hover:text-red-300">
              {isSignUp ? 'Log In' : 'Sign Up'}
            </button>
          </p>
        </div>
        {isSignUp && (
          <div className="text-xs text-slate-400 text-center">
            By signing up, you agree to our{' '}
            <a href="#" className="text-red-400 hover:text-red-300">Terms of Service</a>{' '}
            and{' '}
            <a href="#" className="text-red-400 hover:text-red-300">Privacy Policy</a>
          </div>
        )}
      </div>
    </div>
  );
};

export default LoginPage;